(function () {
  let observer = null;
  let isLoading = false;
  let restoreInProgress = false;
  let mutationObserverStarted = false;
  let pageAbortController = null;
  let gridVersion = 0;
  const requestTimeout = 8000;

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function getStateEl() {
    return document.getElementById('InfiniteScrollState');
  }

  function getTrigger() {
    return document.getElementById('InfiniteScrollTrigger');
  }

  function getButton() {
    return document.getElementById('LoadMoreButton');
  }

  function getSearchInput() {
    return document.getElementById('productSearch');
  }

  function getCurrentPageFromUrl(url) {
    try {
      const parsed = new URL(url, window.location.origin);
      return parseInt(parsed.searchParams.get('page') || '1', 10);
    } catch (e) {
      return 1;
    }
  }

  function getUrlObject(url) {
    return new URL(url || window.location.href, window.location.origin);
  }

  function getPagesParam() {
    const url = getUrlObject();
    const value = parseInt(url.searchParams.get('pages') || '1', 10);
    return Number.isNaN(value) || value < 1 ? 1 : value;
  }

  function setPagesParam(pages) {
    const url = getUrlObject();

    if (pages <= 1) {
      url.searchParams.delete('pages');
    } else {
      url.searchParams.set('pages', String(pages));
    }

    window.history.replaceState({}, '', url.toString());
  }

  function getCurrentViewType() {
    return new URLSearchParams(window.location.search).get('viewtype');
  }

  function normalizeUrlWithCustomParams(rawUrl) {
    const url = getUrlObject(rawUrl);
    const pages = getPagesParam();
    const viewtype = getCurrentViewType();

    url.searchParams.delete('pages');
    if (pages > 1) {
      url.searchParams.set('pages', String(pages));
    }

    if (viewtype) {
      url.searchParams.set('viewtype', viewtype);
    } else {
      url.searchParams.delete('viewtype');
    }

    return url.pathname + url.search + url.hash;
  }

  function updateCustomParamsOnFacetLinks(scope) {
    const root = scope || document;
    const selectors = [
      '.facets a[href]',
      '.active-facets a[href]',
      '.mobile-facets a[href]',
      '.pagination a[href]',
      'a[data-clear-all-link]',
      'a[data-collection-filter-link]'
    ];

    root.querySelectorAll(selectors.join(',')).forEach((link) => {
      const normalized = getUrlObject(normalizeUrlWithCustomParams(link.href));

      // A filter change must always restart infinite scroll from page 1.
      if (link.matches('.facets a[href], .active-facets a[href], .mobile-facets a[href], a[data-clear-all-link], a[data-collection-filter-link]')) {
        normalized.searchParams.delete('pages');
        normalized.searchParams.delete('page');
      }

      link.href = normalized.pathname + normalized.search + normalized.hash;
    });
  }

  function updateButtonVisibility() {
    const stateEl = getStateEl();
    const button = getButton();
    if (!stateEl || !button) return;

    if (stateEl.dataset.nextUrl) {
      button.hidden = false;
      button.disabled = false;
    } else {
      button.hidden = true;
    }
  }

  function markLoading(loading) {
    const button = getButton();
    if (button) {
      button.disabled = loading;
      button.textContent = loading ? 'Laster...' : 'Last inn mer';
    }
  }

  function normalizeText(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .trim();
  }

  function tokenizeSearch(value) {
    return normalizeText(value)
      .split(/\s+/)
      .filter(Boolean);
  }

  function getItemSearchText(item) {
    const combinedSearch = item.dataset.productSearch;

    if (combinedSearch) {
      return normalizeText(combinedSearch);
    }

    return normalizeText([
      item.dataset.productTitle,
      item.dataset.productVendor,
      item.dataset.productType,
      item.dataset.productHandle,
      item.dataset.productTags
    ].filter(Boolean).join(' '));
  }

  function filterRenderedProducts(searchTerm) {
    const grid = getGrid();
    if (!grid) return;

    const items = grid.querySelectorAll('li.grid__item');
    const terms = tokenizeSearch(searchTerm);
    let visibleCount = 0;

    items.forEach((item) => {
      const searchableText = getItemSearchText(item);
      const matches = !terms.length || terms.every((term) => searchableText.includes(term));

      item.style.display = matches ? '' : 'none';

      if (matches) {
        visibleCount += 1;
      }
    });

    let emptyState = document.getElementById('RenderedSearchEmptyState');

    if (!visibleCount && terms.length) {
      if (!emptyState) {
        emptyState = document.createElement('div');
        emptyState.id = 'RenderedSearchEmptyState';
        emptyState.className = 'title-wrapper center';
        emptyState.innerHTML = '<p>Ingen produkter matcher søket.</p>';
        grid.insertAdjacentElement('afterend', emptyState);
      }
    } else if (emptyState) {
      emptyState.remove();
    }
  }

  function reapplyRenderedSearch() {
    const input = getSearchInput();
    const grid = getGrid();
    if (!input || !grid) return;
    if (grid.dataset.collectionMode !== 'infinite') return;

    filterRenderedProducts(input.value);
  }

  function appendItemsFromDocument(doc) {
    const currentGrid = getGrid();
    const nextGrid = doc.getElementById('product-grid');

    if (!currentGrid || !nextGrid) return false;

    const items = nextGrid.querySelectorAll('li.grid__item');
    if (!items.length) return false;

    items.forEach((item) => {
      currentGrid.appendChild(item);
    });

    return true;
  }

  function updateStateFromDocument(doc) {
    const currentState = getStateEl();
    const nextState = doc.getElementById('InfiniteScrollState');

    if (!currentState) return;

    if (nextState) {
      currentState.dataset.currentPage =
        nextState.dataset.currentPage || currentState.dataset.currentPage || '1';

      currentState.dataset.totalPages =
        nextState.dataset.totalPages || currentState.dataset.totalPages || '1';

      if (nextState.dataset.nextUrl) {
        currentState.dataset.nextUrl = normalizeUrlWithCustomParams(nextState.dataset.nextUrl);
      } else {
        delete currentState.dataset.nextUrl;
      }
    } else {
      delete currentState.dataset.nextUrl;
    }

    updateButtonVisibility();
  }

  async function fetchPage(url) {
    const controller = new AbortController();
    pageAbortController = controller;
    let timedOut = false;

    const timeoutId = window.setTimeout(() => {
      timedOut = true;
      controller.abort();
    }, requestTimeout);

    try {
      const response = await fetch(url, {
        method: 'GET',
        signal: controller.signal,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch collection page: HTTP ${response.status}`);
      }

      const html = await response.text();
      return new DOMParser().parseFromString(html, 'text/html');
    } catch (error) {
      if (error.name === 'AbortError' && timedOut) {
        console.warn(`Infinite-scroll request timed out after ${requestTimeout}ms`);
      }
      throw error;
    } finally {
      window.clearTimeout(timeoutId);
      if (pageAbortController === controller) pageAbortController = null;
    }
  }

  async function loadNextPage(options) {
    const stateEl = getStateEl();
    const settings = options || {};
    const preservePagesTarget = settings.preservePagesTarget;
    const targetPages = settings.targetPages;
    const requestGrid = getGrid();
    const requestState = stateEl;
    const requestVersion = gridVersion;

    if (!stateEl || !stateEl.dataset.nextUrl || isLoading) return false;

    isLoading = true;
    markLoading(true);

    try {
      const nextUrl = normalizeUrlWithCustomParams(stateEl.dataset.nextUrl);
      const nextPageNumber = getCurrentPageFromUrl(nextUrl);

      const doc = await fetchPage(nextUrl);

      // The filter may have replaced the grid while this page was downloading.
      if (
        requestVersion !== gridVersion ||
        requestGrid !== getGrid() ||
        requestState !== getStateEl()
      ) {
        return false;
      }

      const appended = appendItemsFromDocument(doc);

      updateStateFromDocument(doc);

      if (appended) {
        if (preservePagesTarget && targetPages > 1) {
          setPagesParam(targetPages);
        } else {
          setPagesParam(nextPageNumber);
        }

        updateCustomParamsOnFacetLinks(document);
        reapplyRenderedSearch();
      }

      if (window.AppsalonRefreshRememberedParams) {
        window.AppsalonRefreshRememberedParams();
      }

      return appended;
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Infinite scroll load error:', error);
      }
      return false;
    } finally {
      if (requestVersion === gridVersion) {
        isLoading = false;
        markLoading(false);
      }
    }
  }

  async function restoreLoadedPages() {
    const stateEl = getStateEl();
    const grid = getGrid();

    if (!stateEl || !grid || restoreInProgress) return;

    const targetPage = getPagesParam();
    const currentPage = parseInt(stateEl.dataset.currentPage || '1', 10);

    if (targetPage <= 1 || currentPage >= targetPage) return;

    restoreInProgress = true;

    try {
      while (true) {
        const nowPage = parseInt(stateEl.dataset.currentPage || '1', 10);

        if (nowPage >= targetPage) break;
        if (!stateEl.dataset.nextUrl) break;

        const loaded = await loadNextPage({
          preservePagesTarget: true,
          targetPages: targetPage
        });

        if (!loaded) break;
      }
    } finally {
      restoreInProgress = false;
    }
  }

  function setupObserver() {
    const trigger = getTrigger();
    if (!trigger) return;

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadNextPage();
          }
        });
      },
      {
        root: null,
        rootMargin: '300px 0px',
        threshold: 0
      }
    );

    observer.observe(trigger);
  }

  function bindButton() {
    const button = getButton();
    if (!button || button.dataset.bound === 'true') return;

    button.dataset.bound = 'true';
    button.addEventListener('click', function () {
      loadNextPage();
    });
  }

  function bindRenderedProductSearch() {
    const searchInput = getSearchInput();
    const grid = getGrid();
    if (!searchInput || !grid) return;
    if (grid.dataset.collectionMode !== 'infinite') return;

    if (searchInput.dataset.bound === 'true') return;
    searchInput.dataset.bound = 'true';

    searchInput.addEventListener('input', function () {
      filterRenderedProducts(this.value);
    });
  }

  function initInfiniteScroll() {
    const stateEl = getStateEl();
    const grid = getGrid();
    if (!stateEl || !grid) return;
    if (grid.dataset.collectionMode !== 'infinite') return;

    if (!window.location.search.includes('pages=')) {
      setPagesParam(parseInt(stateEl.dataset.currentPage || '1', 10));
    }

    if (stateEl.dataset.nextUrl) {
      stateEl.dataset.nextUrl = normalizeUrlWithCustomParams(stateEl.dataset.nextUrl);
    }
    bindButton();
    bindRenderedProductSearch();
    updateButtonVisibility();
    updateCustomParamsOnFacetLinks(document);
    setupObserver();
    reapplyRenderedSearch();
    restoreLoadedPages();
  }

  function startMutationObserver() {
    if (mutationObserverStarted) return;
    mutationObserverStarted = true;

    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!productGridContainer) return;

    const mo = new MutationObserver(() => {
      initInfiniteScroll();
    });

    mo.observe(productGridContainer, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initInfiniteScroll();
    startMutationObserver();
  });

  document.addEventListener('facets:before-render', function () {
    gridVersion += 1;

    if (pageAbortController) {
      pageAbortController.abort();
      pageAbortController = null;
    }

    if (observer) observer.disconnect();

    isLoading = false;
    restoreInProgress = false;
    markLoading(false);
  });

  document.addEventListener('shopify:section:load', function () {
    initInfiniteScroll();
    startMutationObserver();
  });

  document.addEventListener('shopify:section:reorder', function () {
    initInfiniteScroll();
    startMutationObserver();
  });

  document.addEventListener('click', function (event) {
    const link = event.target.closest('.pagination a[href], .facet-filters a[href], .facets a[href], .active-facets a[href], .mobile-facets a[href]');
    if (!link) return;

    const normalized = getUrlObject(normalizeUrlWithCustomParams(link.href));

    if (!link.matches('.pagination a[href]')) {
      normalized.searchParams.delete('pages');
      normalized.searchParams.delete('page');
    }

    link.href = normalized.pathname + normalized.search + normalized.hash;
  });

  document.addEventListener('change', function (event) {
    const target = event.target;
    if (!target) return;

    if (target.matches('#SortBy, #SortBy-mobile')) {
      updateCustomParamsOnFacetLinks(document);
    }
  });
})();
